module.exports = __webpack_public_path__ + "static/img/oneLogin_icon.2d0485b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oneLogin_icon.png
// module id = Qaiq
// module chunks = 1